import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import AppShell from '../../layouts/AppShell.jsx';
import AnonymousShell from '../../layouts/AnonymousShell.jsx';
import { DEFAULT_PAGE_ID, routeForPageId } from '../../layouts/menuData.js';
import { SIGN_IN_PAGE_ID } from '../../layouts/AccountChrome.jsx';
import { useLanguage } from '../../i18n/LanguageContext.jsx';
import { tk } from '../../i18n/translate.js';

const STATUS = {
  401: { icon: 'fa-lock', title: tk('Sign in required'), text: tk('You need to sign in to view this page.'), cta: 'login' },
  403: { icon: 'fa-ban', title: tk('Access denied'), text: tk('Your role does not have permission to open this page.'), cta: 'home' },
  404: { icon: 'fa-compass', title: tk('Page not found'), text: tk('The page you are looking for does not exist or has not been built yet.'), cta: 'home' },
  500: { icon: 'fa-triangle-exclamation', title: tk('Something went wrong'), text: tk('An unexpected error occurred. Please try again in a moment.'), cta: 'home' },
};

/** Themed generic status page rendered inside the shell matching the session state. */
export default function StatusPage({ code = 404 }) {
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();
  const s = STATUS[code] || STATUS[404];
  const Shell = isAuthenticated ? AppShell : AnonymousShell;
  const body = (
    <div className="d-flex justify-content-center py-5">
      <div className="card text-center p-4 p-md-5" style={{ maxWidth: 480, width: '100%' }}>
        <div className="display-1 fw-bold" style={{ color: 'var(--color-primary)' }}>{code}</div>
        <div className="my-3" style={{ color: 'var(--color-muted)', fontSize: 36 }}>
          <i className={`fas ${s.icon}`} aria-hidden="true"></i>
        </div>
        <h1 className="h4">{t(s.title)}</h1>
        <p className="mb-4" style={{ color: 'var(--color-muted)' }}>{t(s.text)}</p>
        {s.cta === 'login' && !isAuthenticated ? (
          <Link to={routeForPageId(SIGN_IN_PAGE_ID)} className="btn btn-primary">{t('Go to sign in')}</Link>
        ) : (
          <Link to={isAuthenticated ? routeForPageId(DEFAULT_PAGE_ID) : '/'} className="btn btn-primary">{t('Back to home')}</Link>
        )}
      </div>
    </div>
  );
  return <Shell>{body}</Shell>;
}

export const Unauthorized = () => <StatusPage code={401} />;
export const Forbidden = () => <StatusPage code={403} />;
export const NotFound = () => <StatusPage code={404} />;
export const ServerError = () => <StatusPage code={500} />;
